import FontFaceObserver from 'fontfaceobserver';
import { loadingView, unloadingView } from '../../../loader.js';
import { jsPDF } from "jspdf";

export default class Backdata {

    constructor(Parent) {
        this.dataParent = Parent;
    }

    rotate(sourceImg, width, height, rotate) {

        const dataParent = this.dataParent;
        return new Promise(function (resolve, reject) {


            if (rotate > 0) {

                let canvastest = document.createElement("canvas");
                canvastest.width = width;
                canvastest.height = height;

                console.log('{rotate', canvastest);


                let ctx = canvastest.getContext("2d");
                //ctx.save();
                if (rotate === 360) {
                    console.log('ROTATE function activation', rotate);
                    ctx.translate(0, canvastest.height);
                    ctx.scale(1, -1);
                }
                ctx.drawImage(sourceImg, 0, 0);
                let newImg = new Image();
                newImg.crossOrigin = "Anonymous";
                newImg.onload = function () {
                    resolve(newImg);

                }
                newImg.src = canvastest.toDataURL();

                //ctx.restore();
                //ctx.clearRect(0, 0, canvastest.width, canvastest.height);
                //console.log('imgpng after rotate destruct', newImg);
                //return newImg;
            }
            else {
                resolve(sourceImg);
            }
        });
    }


    destructPixel(img, width, height) {
        const dataParent = this.dataParent;
        //console.log('destructPixel is cancelled');
        //return img;

        return new Promise(function (resolve, reject) {


            let canvastest = document.createElement("canvas");
            //canvastest.id = 'canvasmama' + dataParent.storage.data.jsonStepCanvas.step;
            canvastest.width = width;
            canvastest.height = height;
            console.log('{destructPixel', canvastest);

            //let canvastest = document.getElementById("canvasmario");
            //let canvastest = document.createElement('canvas');
            //document.body.appendChild(canvastest);

            let ctx = canvastest.getContext("2d");
            /* ctx.save();
             if (rotate == 360) {
                 ctx.translate(0, canvastest.height);
                 ctx.scale(1, -1);
             }*/
            ctx.drawImage(img, 0, 0);


            //ctx.setTransform(1, 0, 0, 1, 0, 0);

            var imgd = ctx.getImageData(0, 0, canvastest.width, canvastest.height),
                pix = imgd.data,
                newColor = { r: 0, g: 0, b: 0, a: 0 };

            for (var i = 0, n = pix.length; i < n; i += 4) {
                var r = pix[i],
                    g = pix[i + 1],
                    b = pix[i + 2];

                if (r == 255 && g == 255 && b == 255) {
                    // Change the white to the new color.
                    pix[i] = newColor.r;
                    pix[i + 1] = newColor.g;
                    pix[i + 2] = newColor.b;
                    pix[i + 3] = newColor.a;
                }
            }

            ctx.putImageData(imgd, 0, 0);

            let imgpng = new Image();
            imgpng.crossOrigin = "Anonymous";
            imgpng.onload = function () {
                resolve(imgpng);
            }

            imgpng.src = canvastest.toDataURL();

            //var element = document.getElementById('main');
            //element.appendChild(canvastest);
            //ctx.restore();
            //ctx.clearRect(0, 0, canvastest.width, canvastest.height);
        });

    }



    async addfaceAVToPDF(canvas, data) {
        console.log("[addfaceAVToPDF]", data);
        const dataParent = this.dataParent;
        dataParent.class.Dom.updateLoading("- Création de l'étape " + data.jsonStepCanvas.step + " en cours ...", "addstep" + data.jsonStepCanvas.step);

        return new Promise(function (resolve, reject) {
            // IF NO MASK FOR THIS PRODUCT
            if (!dataParent.storage.pyml.mask || !dataParent.storage.pyml.mask.back) {
                canvas.overlayImage = null;

                // CADRE
                if (dataParent.storage.pyml.pdf.line) {
                    var line = dataParent.storage.pyml.pdf.line[dataParent.storage.key_taille];
                    var arrLine = line.split(",");
                    var x1 = new Number(arrLine[0]);
                    var y1 = new Number(arrLine[1]);
                    var x2 = new Number(arrLine[2]);
                    var y2 = new Number(arrLine[3]);

                    dataParent.storage.docPdf.setDrawColor(150, 150, 150);
                    // HORIZONTAL
                    dataParent.storage.docPdf.line(x1, y1, x2, y2);
                }

                var coords = dataParent.storage.pyml.pdf.coords.step[data.jsonStepCanvas.step].size[dataParent.storage.key_taille];
                var arrCoords = coords.split(",");
                var dimensions = dataParent.storage.pyml.pdf.produit[dataParent.storage.key_taille];
                var arrDimensions = dimensions.split(",");
                var width = new Number(arrDimensions[0]);
                var height = new Number(arrDimensions[1]);
                if (data.iterationLoop > 0) {
                    var loopSpace = data.iterationLoop * width - width + data.iterationLoop - 1;
                    var x = new Number(arrCoords[0]) + loopSpace;
                } else {
                    var x = new Number(arrCoords[0]);
                }
                console.log('arrCoords[0]', arrCoords[0]);
                console.log('loopSpace', loopSpace);
                var y = new Number(arrCoords[1]);

                let rotate = 0;
                if (dataParent.storage.pyml.pdf.rotate) {
                    rotate = dataParent.storage.pyml.pdf.rotate.step[data.jsonStepCanvas.step].size[dataParent.storage.key_taille];
                }


                console.log('coords xy faceav', x, y);
                console.log('dimensions faceav', width, height);
                var img = new Image();
                img.crossOrigin = "Anonymous";
                img.id = data.iterationLoop;
                img.onload = function () {
                    $("body").append(
                        '<img id="' + data.iterationLoop + '" src=' + img.src + " />"
                    );

                    dataParent.storage.docPdf.addImage(
                        img,
                        "JPEG",
                        x,
                        y,
                        width,
                        height,
                        "frontface" + data.iterationLoop,
                        "NONE",
                        rotate
                    );
                    dataParent.class.Dom.updateLoading("» Création de la face avant OK", "addfaceAVToPDF");
                    console.log(
                        "#####################arguments.callee.name de resolve face avant : addfaceAVToPDF"
                    );
                    resolve(img);
                };

                canvas.renderAll.bind(canvas);
                img.src = canvas.toDataURL({
                    quality: 1,
                    top: dataParent.storage.pyml.canvaspx.coords.front.top[dataParent.storage.key_taille],
                    left: dataParent.storage.pyml.canvaspx.coords.front.left[dataParent.storage.key_taille],
                    width: dataParent.storage.pyml.canvaspx.coords.front.width[dataParent.storage.key_taille],
                    height: dataParent.storage.pyml.canvaspx.coords.front.height[dataParent.storage.key_taille],
                });
            } else {
                console.log('Add mask admin for step ' + data.jsonStepCanvas.step);
                canvas.setOverlayImage("/modules/personnalisation/views/img/overlays/mask_idproduct_" + dataParent.storage.id_product + "_step_" + data.jsonStepCanvas.step + "_admin.png?rand=" + Math.random(),
                    function () {
                        canvas.renderAll.bind(canvas);
                        canvas.calcOffset();


                        let imageProduitFaceAvant = new Image();
                        imageProduitFaceAvant.crossOrigin = "Anonymous";
                        imageProduitFaceAvant.onload = function () {


                            /*let imgpng = imageProduitFaceAvant;
                            // ROTATE IMG IF ACTIVE
                            const rotation = parseInt(dataParent.storage.pyml.mask.rotate.step[dataParent.storage.data.jsonStepCanvas.step]['size'][dataParent.storage.key_taille]);
                            if (rotation > 0) {
                                imgpng = dataParent.class.Back.rotate(imgpng, rotation);
                            }*/

                            // DELETE ALL WHITE PIXELS
                            //console.log('imageProduitFaceAvant avant destruct', imgpng);
                            (async function () {
                                let imgpng;
                                dataParent.storage.pyml
                                const canvasWidth = dataParent.storage.pyml.canvaspx.coords.front.width[dataParent.storage.key_taille];
                                const canvasHeight = dataParent.storage.pyml.canvaspx.coords.front.height[dataParent.storage.key_taille];
                                // ROTATE IMG IF ACTIVE
                                let rotation = 0;
                                if (dataParent.storage.pyml.mask.rotate.step) {
                                    rotation = parseInt(dataParent.storage.pyml.mask.rotate.step[dataParent.storage.data.jsonStepCanvas.step]['size'][dataParent.storage.key_taille]);
                                }
                                if (rotation > 0) {
                                    const imgRotated = await dataParent.class.Back.rotate(imageProduitFaceAvant, canvasWidth, canvasHeight, rotation);
                                    imgpng = await dataParent.class.Back.destructPixel(imgRotated, canvasWidth, canvasHeight);
                                }
                                else {
                                    imgpng = await dataParent.class.Back.destructPixel(imageProduitFaceAvant, canvasWidth, canvasHeight);
                                }
                                console.log('rotation pixel', rotation);

                                var coords = dataParent.storage.pyml.pdf.coords.step[data.jsonStepCanvas.step].size[dataParent.storage.key_taille];
                                var arrCoords = coords.split(",");
                                var x = new Number(arrCoords[0]);
                                var y = new Number(arrCoords[1]);


                                //var width = objs[id_product].pdf.produit[key_taille];
                                //var height = calHeightProductSpecialHeight(objs[id_product].pdf.produit[key_taille], objs[id_product].mask.front['height']);

                                var dimensions = dataParent.storage.pyml.pdf.produit[dataParent.storage.key_taille];
                                if (dimensions.indexOf(",") !== -1) {
                                    var arrDimensions = dimensions.split(",");
                                    var width = new Number(arrDimensions[0]);
                                    var height = new Number(arrDimensions[1]);
                                } else {
                                    var width = dataParent.storage.pyml.pdf.produit[dataParent.storage.key_taille];
                                    var height = dataParent.class.Back.calHeightProductSpecialHeight(
                                        dataParent.storage.pyml.pdf.produit[dataParent.storage.key_taille],
                                        dataParent.storage.pyml.mask.front["height"]
                                    );
                                }

                                let biggest, smallest;
                                if (width > height) {
                                    biggest = width;
                                    smallest = height;
                                }
                                else {
                                    biggest = height;
                                    smallest = width;

                                }

                                var rotate = 0;
                                let finalx = x;
                                let finaly = y;


                                if (dataParent.storage.pyml.mask.rotate && dataParent.storage.pyml.mask.rotate.step[data.jsonStepCanvas.step]['size'][dataParent.storage.key_taille]) {
                                    rotate = parseInt(dataParent.storage.pyml.mask.rotate.step[data.jsonStepCanvas.step]['size'][dataParent.storage.key_taille]);
                                }
                                if (rotate === 270) {
                                    finalx = x;
                                    finaly = y - biggest;
                                    //finalx = (data.jsonStepCanvas.step * width) - width;
                                }
                                if (rotate === 90) {
                                    finalx = x + height;
                                    finaly = y + (biggest - smallest);
                                }

                                console.log('coords xy faceav', finalx, finaly);
                                console.log('dimensions faceav', width, height);

                                dataParent.storage.docPdf.addImage(
                                    imgpng,
                                    "PNG",
                                    finalx,
                                    finaly,
                                    width,
                                    height,
                                    "step_" + data.jsonStepCanvas.step,
                                    "NONE",
                                    rotate
                                );

                                dataParent.class.Dom.updateLoading("» Création de la face avant OK", "addfaceAVToPDF");
                                resolve("promise_faceAV terminé");
                            })();
                        };

                        imageProduitFaceAvant.src = canvas.toDataURL({
                            quality: 1,
                            top: dataParent.storage.pyml.canvaspx.coords.front.top[dataParent.storage.key_taille],
                            left: dataParent.storage.pyml.canvaspx.coords.front.left[dataParent.storage.key_taille],
                            width: dataParent.storage.pyml.canvaspx.coords.front.width[dataParent.storage.key_taille],
                            height: dataParent.storage.pyml.canvaspx.coords.front.height[dataParent.storage.key_taille],
                        });


                    },
                    {
                        opacity: 1,
                        scaleX: 1,
                        scaleY: 1,
                        width: parseInt(dataParent.storage.pyml.mask.back["width"]),
                        height: parseInt(dataParent.storage.pyml.mask.back["height"]),
                    }
                );
            }
            console.log("FACE AVANT ADD TO PDF", width, height);
        });
    };


    addBeltToPDF(canvas, object) {
        console.log('[addBeltToPDF]', canvas, object)
        if (typeof object.ceinture != "undefined") {
            // BELT

            var BeltHeightCm = 4.5;
            var fabricObj_belt = this.dataParent.class.Canvas.getObject(canvas, "fabricObj_belt", 'ceinture');
            console.log('fabricObj_belt', fabricObj_belt);
            this.dataParent.storage.docPdf.setFillColor(fabricObj_belt.fill);
            this.dataParent.storage.docPdf.rect(1, 0.5, parseFloat(object.ceinture[this.dataParent.storage.key_taille]), BeltHeightCm, "F");
            var centerImage = parseFloat(object.ceinture[this.dataParent.storage.key_taille]) / 2 - 30.77 / 2;
            /* docPdf.addImage(
              imageCeinture,
              "JPEG",
              2 + centerImage,
              2.3,
              30.77,
              BeltHeightCm - 0.6,
              "ceinture"
            );*/
            var centerImage = parseFloat(object.ceinture[this.dataParent.storage.key_taille]) / 2;
            //objectCeinture.fontSize = 110;
            console.log("centerImage", centerImage);
            console.log("canvas pour ceinture", canvas);
            console.log("object pour ceinture", object);
            var textCeinture = this.dataParent.class.Canvas.getTextFromObject(canvas, "fabricObj_text");
            console.log("text ceinture", textCeinture);
            var objectCeinture = this.dataParent.class.Canvas.getObject(canvas, "fabricObj_text", 'text');
            console.log("objectCeinture ceinture", objectCeinture);
            var textBeltForPDF = {
                text: objectCeinture.text,
                fontSize: 90,
                left: 1 + centerImage,
                top: 3.8,
                angle: 0,
                fontFamily: objectCeinture.fontFamily,
                fontStyle: objectCeinture.fontStyle,
                fill: objectCeinture.fill,
                align: "center",
            };
            this.dataParent.class.Canvas.putText(this.dataParent.storage.docPdf, textBeltForPDF);
            console.log("BELT CREATION ADD TO PDF");
        }
    };

    addBandToPDF(canvas, object) {
        console.log('[addBandToPDF]', canvas, object)
        if (typeof object.bande != "undefined") {

            var BandHeightCm = 4;
            // var coords = this.dataParent.class.Dom.arrSplit(object.pdf.coords.bande[this.dataParent.storage.key_taille]);
            // console.log('coords bande', coords);
            // console.log('coords[0]', coords[0]);
            // console.log('coords[1]', coords[1]);
            console.log('key taille bande', parseFloat(object.bande[this.dataParent.storage.key_taille]));
            this.dataParent.storage.docPdf.setFillColor(0, 0, 0);
            // this.dataParent.storage.docPdf.setLineWidth(0.4)
            var heightPdf = object.pdf.height[this.dataParent.storage.key_taille];
            var widthBand = object.bande[this.dataParent.storage.key_taille];
            console.log('heightPdf', heightPdf);
            console.log('widthBand', widthBand);

            // FIRST BAND
            this.dataParent.storage.docPdf.rect(1, heightPdf - 4 - 1, parseFloat(object.bande[this.dataParent.storage.key_taille]), BandHeightCm, "F");

            this.dataParent.storage.docPdf.rect(1, heightPdf - 4 - 1 - 4 - 1, parseFloat(object.bande[this.dataParent.storage.key_taille]), BandHeightCm, "F");

            this.dataParent.storage.docPdf.rect(1, heightPdf - 4 - 1 - 4 - 1 - 4 - 1, parseFloat(object.bande[this.dataParent.storage.key_taille]), BandHeightCm, "F");

            console.log("BAND CREATION ADD TO PDF");
        }
    };

    addDoublureToPDF(canvas, object) {
        const dataParent = this.dataParent;
        if (typeof object.doublure != "undefined") {
            //var dimensions = this.dataParent.class.Dom.arrSplit(object.doublure[this.dataParent.storage.key_taille]);

            var dimensions = dataParent.storage.pyml.doublure[dataParent.storage.key_taille];
            if (dimensions.indexOf(",") !== -1) {
                var arrDimensions = dimensions.split(",");
                var width = new Number(arrDimensions[0]);
                var height = new Number(arrDimensions[1]);
            } else {
                var width = dataParent.storage.pyml.doublure[dataParent.storage.key_taille];
                var height = dataParent.class.Back.calHeightProductSpecialHeight(
                    dataParent.storage.pyml.pdf.produit[dataParent.storage.key_taille],
                    dataParent.storage.pyml.mask.front["height"]
                );
            }

            var coords = this.dataParent.class.Dom.arrSplit(object.pdf.coords.doublure[this.dataParent.storage.key_taille]);

            (async function () {
                let imgpngfinale;
                let objectRotate = 0;
                if (object.rotate && object.rotate.doublure) {
                    objectRotate = object.rotate.doublure[dataParent.storage.key_taille];
                }

                const canvasWidth = dataParent.storage.pyml.mask.doublure.width;
                const canvasHeight = dataParent.storage.pyml.mask.doublure.height;

                // ROTATE IMG IF ACTIVE
                if (objectRotate > 0) {
                    imgpngfinale = await dataParent.class.Back.rotate(dataParent.storage.imageDoublureFinale, canvasWidth, canvasHeight, objectRotate);
                    if (dataParent.storage.id_product == '14811') {
                        imgpngfinale = await dataParent.class.Back.destructPixel(imgpngfinale, canvasWidth, canvasHeight);
                    }
                }
                else {
                    imgpngfinale = dataParent.storage.imageDoublureFinale;
                    if (dataParent.storage.id_product == '14811') {
                        imgpngfinale = await dataParent.class.Back.destructPixel(imgpngfinale, canvasWidth, canvasHeight);
                    }
                }

                dataParent.storage.docPdf.setDrawColor(0, 0, 0);
                dataParent.storage.docPdf.addImage(
                    imgpngfinale,
                    "JPEG",
                    coords[0],
                    coords[1],
                    width,
                    height,
                    "doublure",
                    "NONE",
                    objectRotate
                );
                console.log("DOUBLURE CREATION ADD TO PDF", coords, width, height);
            })();
        }
    };

    addEntrejambeToPDF(canvas, object) {
        if (typeof object.entrejambe != "undefined") {
            var dimensions = this.dataParent.class.Dom.arrSplit(object.entrejambe[this.dataParent.storage.key_taille]);
            var coords = this.dataParent.class.Dom.arrSplit(object.pdf.coords.entrejambe[this.dataParent.storage.key_taille]);

            var largeur = dimensions[0]; // 21
            var longueur = dimensions[1]; // 8

            var x = coords[0];
            var y = coords[1];
            var masque = false;

            if (this.dataParent.storage.id_product == "10016") {
                masque = true;
            } else if (this.dataParent.storage.id_product == "10018") {
                masque = true;
            }

            console.log('masque & id_product', masque, this.dataParent.storage.id_product);


            console.log('x - longueur', x - longueur);
            console.log('y - (largeur - longueur)', y - (largeur - longueur));
            console.log('longueur', longueur);
            console.log('largeur', largeur);


            if (masque === false) {
                this.dataParent.storage.docPdf.setDrawColor(226, 226, 226);
                this.dataParent.storage.docPdf.setLineWidth(0.4);
                if (object.rotate.entrejambe[this.dataParent.storage.key_taille] != "0") {
                    this.dataParent.storage.docPdf.rect(
                        x - longueur,
                        y - (largeur - longueur),
                        longueur,
                        largeur
                    );
                } else {
                    this.dataParent.storage.docPdf.rect(x, y, largeur, longueur);
                }

                this.dataParent.storage.docPdf.setDrawColor(0, 0, 0);
                if (object.rotate.entrejambe[this.dataParent.storage.key_taille] == "90") {
                    // VERTICAL
                    this.dataParent.storage.docPdf.line(
                        x - longueur / 2,
                        y - largeur / 2 - 1.5,
                        x - longueur / 2,
                        y + longueur + 0.5
                    );
                    // HORIZONTAL
                    // IF ROTATE -> Y center = y + Real largeur - (real longueur / 2)
                    this.dataParent.storage.docPdf.line(
                        x - longueur - 0.5,
                        y + dimensions[1] - dimensions[0] / 2,
                        x + 0.5,
                        y + dimensions[1] - dimensions[0] / 2
                    );
                }
            }
            this.dataParent.storage.docPdf.addImage(
                this.dataParent.storage.imageFondPropreteFinale,
                "JPEG",
                x,
                y,
                largeur,
                longueur,
                "entrejambe",
                "NONE",
                object.rotate.entrejambe[this.dataParent.storage.key_taille]
            );
            console.log("ENTRE JAMBE CREATION ADD TO PDF");
        }
    };

    outPDF(doc, arr_id_personnalisation, filename) {
        doc.setDisplayMode("fullpage", "continuous", "UseOutlines");
        this.dataParent.storage.zip.file(filename + ".pdf", doc.output("blob"));

        var nb = arr_id_personnalisation.length;

        const dataParent = this.dataParent;
        // SAVE
        this.dataParent.storage.zip.generateAsync({
            type: "blob",
            compression: "DEFLATE",
            compressionOptions: {
                level: 9,
            },
        }).then(function (content) {

            dataParent.class.Dom.updateLoading("» création du PDF OK", "outPDF");
            unloadingView("chargement_canvas");
            doc.output("save", filename + ".pdf");
            console.log("OUT PDF");
        });
    };

    createPDF(widthCm, heightCm) {
        console.log('widthCm:', widthCm);
        console.log('heightCm:', heightCm);
        var doc = new jsPDF({
            orientation: "landscape",
            unit: "cm",
            format: [widthCm, heightCm],
        });

        // Optional - set properties on the document
        doc.setProperties({
            title: "Personnallisation - LABOUTIQUEDUBOXER.COM",
            subject: "Patron pour produit",
            author: "DE RIGHI Sébastien",
            keywords: "boxer, personnalisation",
            creator: "DE RIGHI Sébastien",
        });

        // CREATE WHITE BACKGROUND RECT
        doc.setFillColor(255, 255, 255);
        doc.rect(0, 0, 111, heightCm, "F");

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.01);
        /* doc.rect(0.2, 0.2, 152.5, 62.80);*/

        return doc;
    };

    doublure(canvasName, data) {
        console.log(data);
        this.dataParent.class.Dom.updateLoading("- Création de la doublure en cours ...", "doublure");
        const dataParent = this.dataParent;
        const maskDoublureWidth = parseInt(dataParent.storage.pyml.mask.doublure["width"]);
        const maskDoublureHeight = parseInt(dataParent.storage.pyml.mask.doublure["height"]);
        return new Promise(function (resolve, reject) {
            var imageDoublure_canvasProduit = new Image();
            imageDoublure_canvasProduit.crossOrigin = "Anonymous";
            imageDoublure_canvasProduit.onload = function () {
                // CREATE CANVAS AND DOUBLURE
                var canvasDoublure = new fabric.Canvas("canvas_doublure_html", {
                    /*backgroundColor: 'rgb(100,100,200)',*/
                    width: maskDoublureWidth,
                    height: maskDoublureHeight,
                    preserveObjectStacking: true,
                    stateful: true,
                    overlayVpt: true, // important
                    BackgroundVpt: true,
                    noScaleCache: true,
                    centeredScaling: true,
                    objectCaching: false,
                });

                if (data.json.id_product == '10016' || data.json.id_product == '10018') {
                    var textSize = new fabric.Text(data.taille, {
                        fill: "#666",
                        fontSize: 36,
                        originX: "left",
                        originY: "center",
                        left: 190,
                        top: 220,
                        angle: 90,
                    });
                }
                else if (data.json.id_product == '14811' || data.json.id_product == '14812') {
                    var textSize = new fabric.Text(data.taille, {
                        fill: "#666",
                        fontSize: 18,
                        originX: "left",
                        originY: "center",
                        left: 815,
                        top: 1308,
                        angle: 0,
                    });


                    console.log('optionsSelling ok ?', dataParent.storage.stepJsonCanvas[dataParent.storage.id_product][1].optionsSelling);
                    console.log('outline ok ?', dataParent.storage.stepJsonCanvas[dataParent.storage.id_product][1].optionsSelling.outline.use);
                    let optionSelling = dataParent.storage.stepJsonCanvas[dataParent.storage.id_product][1].optionsSelling;

                    if (optionSelling !== undefined && optionSelling.outline !== undefined) {

                        let numOverlayValue = dataParent.storage.stepJsonCanvas[dataParent.storage.id_product][1].numOverlay;
                        console.log('numOverlay ok ?', numOverlayValue);
                        console.log('text biais color', dataParent.storage.pyml.mask.colors.text);
                        console.log('text biais', dataParent.storage.pyml.mask.colors.text[numOverlayValue]);
                        var textBiais = new fabric.Text(dataParent.storage.pyml.mask.colors.text[numOverlayValue], {
                            fill: "#666",
                            fontSize: 40,
                            originX: "left",
                            originY: "center",
                            left: 2100,
                            top: 500,
                            angle: 90,
                        });
                        canvasDoublure.add(textBiais);

                    }
                } else if (data.json.id_product == '15038') {
                    var textSize = new fabric.Text(data.taille, {
                        fill: "#666",
                        fontSize: 19,
                        originX: "left",
                        originY: "center",
                        left: 240,
                        top: 408,
                    });
                } else {
                    var textSize = new fabric.Text(data.taille, {
                        fill: "#666",
                        fontSize: 19,
                        originX: "left",
                        originY: "center",
                        left: 213,
                        top: 721,
                    });
                }

                canvasDoublure.add(textSize);
                canvasDoublure.renderAll.bind(canvasDoublure);
                canvasDoublure.calcOffset();
                const imageDoublure = new fabric.Image(imageDoublure_canvasProduit);


                canvasDoublure.centerObject(imageDoublure);
                console.log("overlay doublure", "/modules/personnalisation/views/img/masque_" + dataParent.storage.id_product + "_doublure.png");
                canvasDoublure.setOverlayImage("/modules/personnalisation/views/img/masque_" + dataParent.storage.id_product + "_doublure.png", function () {
                    let imageDoublureFinale = new Image();
                    imageDoublureFinale.crossOrigin = "Anonymous";
                    imageDoublureFinale.onload = function () {
                        $("#img_doublure_html").append(imageDoublureFinale);

                        dataParent.class.Dom.updateLoading("» Création de la doublure OK", "doublure");
                        dataParent.storage.imageDoublureFinale = imageDoublureFinale;

                        resolve("promise_doublure terminé");
                        console.log("promise_doublure terminée");
                    };

                    imageDoublureFinale.src = canvasDoublure.toDataURL({
                        quality: 1,
                    });
                },
                    {
                        opacity: 1,
                    }
                );
                console.log("DOUBLURE ADD TO PDF");
            };

            imageDoublure_canvasProduit.src = canvasName.toDataURL({
                quality: 1,
                left: canvasName.width / 2 - maskDoublureWidth / 2,
                top: canvasName.height / 2 - maskDoublureHeight / 2 + 70,
                width: maskDoublureWidth,
                height: maskDoublureHeight,
            });
        });
    };

    async entrejambetest(canvasName, data) {
        console.log('[entrejambe]');
        const dataParent = this.dataParent;
        return new Promise(function (resolve, reject) {
            dataParent.class.Dom.updateLoading("- Création de l'entrejambe ...", "entrejambe");



            canvasName.setOverlayImage(null, canvasName.renderAll.bind(canvasName));
            canvasName.renderAll();
            canvasName.calcOffset();

            if (dataParent.storage.pyml.mask.entrejambe) {
                var dimensions = dataParent.storage.pyml.mask.entrejambe[dataParent.storage.key_taille];
                if (dimensions.indexOf(",") !== -1) {
                    var arrDimensions = dimensions.split(",");
                    var width = new Number(arrDimensions[0]);
                    var height = new Number(arrDimensions[1]);
                } else {
                    var width = dataParent.storage.pyml.entrejambe[dataParent.storage.key_taille];
                    var height = dataParent.class.Back.calHeightProductSpecialHeight(
                        dataParent.storage.pyml.pdf.produit[dataParent.storage.key_taille],
                        dataParent.storage.pyml.mask.front["height"]
                    );
                }
            }
            else {
                var entrejambeDimensions = dataParent.storage.pyml.entrejambe[dataParent.storage.key_taille]; // rebord
                var arrEntrejambeDimensions = entrejambeDimensions.split(",");
                var entrejambeWidth = new Number(arrEntrejambeDimensions[0]);
                var entrejambeHeight = new Number(arrEntrejambeDimensions[1]);


                var width = entrejambeWidth * 45;
                var height = entrejambeHeight * 45;
                var masque = false;
            }




            var imageEntrejambe = new Image();
            imageEntrejambe.crossOrigin = "Anonymous";
            imageEntrejambe.onload = function () {

                dataParent.storage.imageFondPropreteFinale = imageEntrejambe;
                resolve("promise_entrejambe terminé");
                // var canvasEntreJambe = new fabric.StaticCanvas(
                //     "canvas_entrejambe_html",
                //     {
                //         width: 2000,
                //         height: 500,
                //         preserveObjectStacking: true,
                //         stateful: true,
                //         overlayVpt: true, //important
                //         BackgroundVpt: true,
                //         noScaleCache: true,
                //         centeredScaling: true,
                //         objectCaching: false,
                //     }
                // );
                // canvasEntreJambe.renderAll.bind(canvasEntreJambe);
                // canvasEntreJambe.calcOffset();

                //                 const imageFondProprete = new fabric.Image(imageEntrejambe);
                // 
                // 
                // 
                //                         canvasEntreJambe.renderAll.bind(canvasEntreJambe);
                //                         canvasEntreJambe.calcOffset();
                // 
                //                         let imageFondPropreteFinale = new Image();
                //                         imageFondPropreteFinale.crossOrigin = "Anonymous";
                //                         imageFondPropreteFinale.onload = function () {
                //                             $("#img_fondproprete_html").append(imageFondPropreteFinale);
                // 
                //                             $("#img_entrejambe_html").append(imageEntrejambe);
                //                             dataParent.storage.imageFondPropreteFinale = imageFondPropreteFinale;
                //                             resolve("promise_entrejambe terminé");
                //                             console.log("promise_entrejambe terminée");
                //                         };
                //                         imageFondPropreteFinale.src = canvasEntreJambe.toDataURL({
                //                             quality: 1,
                //                         });

            };
            console.log('width final : ', width);
            console.log('height final : ', height);
            imageEntrejambe.src = canvasName.toDataURL({
                quality: 1,
                left: canvasName.width / 2 - width / 2,
                top: canvasName.height / 2 - height / 2,
                // width: 1276,
                // height: 277,
                width: width,
                height: height,
            });
        });
    };

    async entrejambe(canvasName, data) {
        console.log('[entrejambe]');
        const dataParent = this.dataParent;
        return new Promise(function (resolve, reject) {
            dataParent.class.Dom.updateLoading("- Création de l'entrejambe ...", "entrejambe");
            var entrejambeDimensions = dataParent.storage.pyml.entrejambe[dataParent.storage.key_taille]; // rebord
            var arrEntrejambeDimensions = entrejambeDimensions.split(",");
            var entrejambeWidth = new Number(arrEntrejambeDimensions[0]);
            var entrejambeHeight = new Number(arrEntrejambeDimensions[1]);
            entrejambeWidth = entrejambeWidth + 0.4;
            entrejambeHeight = entrejambeHeight + 0.4;

            var width = entrejambeWidth * 45;
            var height = entrejambeHeight * 45;
            var masque = false;

            if (dataParent.storage.id_product == "10016") {
                width = 561;
                height = 687;
                masque = true;
                var textLeft = width / 2 - 97; // negatif = baisse vers le bas car deja rotation
                var textTop = height / 2 - 320;
            } else if (dataParent.storage.id_product == "10018") {
                width = 561;
                height = 687;
                masque = true;
                var textLeft = width / 2 - 114;
                var textTop = height / 2 - 320;
            }
            masque = false;
            if (masque === false) {
                canvasName.setOverlayImage(null, canvasName.renderAll.bind(canvasName));
                canvasName.renderAll();
                canvasName.calcOffset();
            }
            var imageEntrejambe = new Image();
            imageEntrejambe.crossOrigin = "Anonymous";
            imageEntrejambe.onload = function () {
                if (masque === true) {
                    // SI MASQUE A AJOUTER
                    var canvasEntreJambe = new fabric.StaticCanvas(
                        "canvas_entrejambe_html",
                        {
                            width: width,
                            height: height,
                            preserveObjectStacking: true,
                            stateful: true,
                            overlayVpt: true, //important
                            BackgroundVpt: true,
                            noScaleCache: true,
                            centeredScaling: true,
                            objectCaching: false,
                        }
                    );

                    /*var textSize = new fabric.Text("Taille " + data.taille, {
                        fill: "#777",
                        fontSize: 26,
                        originX: "left",
                        originY: "center",
                        angle: 90,
                        left: textLeft,
                        top: textTop,
                    });
                    canvasEntreJambe.add(textSize);*/
                    canvasEntreJambe.renderAll.bind(canvasEntreJambe);
                    canvasEntreJambe.calcOffset();

                    const imageFondProprete = new fabric.Image(imageEntrejambe);

                    //canvasEntreJambe.add(imageFondProprete);
                    //canvasEntreJambe.centerObject(imageFondProprete);

                    // LOGO
                    let sigle = "";
                    /*if (data.json.heritage == "1") {
                        sigle = "";
                    } else {
                        sigle = "_lbdb";
                    }*/

                    //canvasDoublure.centerObject(imageDoublure);
                    console.log("overlay entrejambe", "/modules/personnalisation/views/img/masque_" + dataParent.storage.id_product + "_entrejambe" + sigle + ".png");




                    canvasEntreJambe.setOverlayImage(
                        "/modules/personnalisation/views/img/masque_" + dataParent.storage.id_product + "_entrejambe" + sigle + ".png",
                        function () {
                            canvasEntreJambe.renderAll.bind(canvasEntreJambe);
                            canvasEntreJambe.calcOffset();

                            let imageFondPropreteFinale = new Image();
                            imageFondPropreteFinale.crossOrigin = "Anonymous";
                            imageFondPropreteFinale.onload = function () {
                                $("#img_fondproprete_html").append(imageFondPropreteFinale);

                                $("#img_entrejambe_html").append(imageEntrejambe);
                                dataParent.storage.imageFondPropreteFinale = imageFondPropreteFinale;
                                resolve("promise_entrejambe terminé");
                                console.log("promise_entrejambe terminée");
                            };
                            imageFondPropreteFinale.src = canvasEntreJambe.toDataURL({
                                quality: 1,
                            });

                        },
                        {
                            opacity: 1,
                        }
                    );
                } else {
                    dataParent.storage.imageFondPropreteFinale = imageEntrejambe;
                    $("#img_entrejambe_html").append(imageEntrejambe);
                    dataParent.class.Dom.updateLoading("» Création de la doublure OK", "entrejambe");
                    resolve("promise_entrejambe terminé");
                    console.log("promise_entrejambe terminée");
                }
            };
            imageEntrejambe.src = canvasName.toDataURL({
                quality: 1,
                left: canvasName.width / 2 - width / 2,
                top: canvasName.height / 2 - height / 2,
                width: width,
                height: height,
            });
        });
    };



    traceTexts(docName, data) {
        console.log("traceTexts data", data);
        const dataParent = this.dataParent;
        return new Promise(function (resolve, reject) {
            dataParent.class.Dom.updateLoading("- Création des textes dynamiques ...", "traceTexts");
            var objTexts = {
                idOrder: dataParent.storage.id_order,
                id_customization: data.id_customization,
                taille: data.taille,
                //qty: dataParent.storage.objs["qty"][dataParent.storage.key_taille - 1],
            };

            switch (dataParent.storage.id_product) {
                case "10015":
                case "10016":
                case "10017":
                case "10018":
                case "14811":
                case "14812":
                case "15034":
                case "15038":
                    // WIDTH ADJUSTMENT FOR ROTATION OF TEXT LENGTH ( 6/8 ans or M)
                    let variableSpace = 0.8;
                    // console.log('objTexts.text', objTexts.text);
                    if (objTexts.taille.length === 2) {
                        variableSpace = 0.6;
                    }
                    else if (objTexts.taille.length === 1) {
                        variableSpace = 0.5;
                    }
                    objTexts.logoOrderTextLeft = parseFloat(dataParent.storage.pyml.ceinture[dataParent.storage.key_taille]) + dataParent.storage.space + variableSpace;
                    objTexts.logoOrderTextTop = dataParent.storage.space + 1;

                    // LOGO CEINTURE
                    /*if (data.json.heritage == "1") {
                        var beltImg = "etiquette-arriere-ceinture-heritage.jpg";
                    } else {
                        var beltImg = "etiquette-arriere-ceinture.jpg";
                    }*/


                    // var beltImg = "etiquette-arriere-ceinture-heritage.jpg";

                    // let xSquare = parseFloat(dataParent.storage.pyml.ceinture[dataParent.storage.key_taille]) + 2;
                    // let ySquare = 0.5;
                    // console.log('dataParent.storage.key_taille', dataParent.storage.key_taille);
                    // if (dataParent.storage.key_taille >= 6) {
                    //     xSquare = 1;
                    //     ySquare = 6.5;
                    // }
                    // dataParent.storage.docPdf.addImage(
                    //     "/modules/personnalisation/views/img/" + beltImg,
                    //     "JPEG",
                    //     xSquare,
                    //     ySquare,
                    //     3.94,
                    //     4.5,
                    //     "logo"
                    // );

                    let SizeBeltText = {
                        text: objTexts.taille,
                        fontSize: 13,
                        left: objTexts.logoOrderTextLeft,
                        top: objTexts.logoOrderTextTop,
                        angle: -90,
                        fontFamily: "Arial",
                        fontStyle: "bold",
                        fill: "#666666",
                        align: "center",
                    };
                    dataParent.class.Canvas.putText(docName, SizeBeltText);
                    // console.log(SizeBeltText);
                    // console.log(objTexts);
                    // console.log('width belt', parseFloat(dataParent.storage.pyml.ceinture[dataParent.storage.key_taille]));
                    break;

                default:
            }

            // DETAIL COMMANDE
            /*var detailOrderText = {
                  text: 'N°' + objTexts.id_customization + '  -  ' + objTexts.taille + '  -  QTE ' + objTexts.qty,
                  fontSize: 20,
                  left: 1.3,
                  top: 9,
                  angle: 90,
                  fontFamily: 'Arial',
                  fill: '#000000'
                  };
                  putText(docName, detailOrderText);*/
            dataParent.class.Dom.updateLoading("» Création des textes dynamiques OK", "traceTexts");
            resolve("promise_textes terminé");
            console.log("promise_textes terminée");
        });
    };

    download_project() {
        console.log("download_project");
        var canvas = document.getElementById("canvas_admin");
        canvas.toBlob(function (blob) {
            saveAs(blob, "canvas_images.png");
        });
    };

    calHeightProductSpecialHeight(widthCm, height) {
        console.log("widthCm : " + widthCm);
        console.log("height : " + height);
        var finalHeight = (widthCm * height) / 2745;
        // var finalHeight = (widthCm * height) / 2745;
        return finalHeight;
    };

    calHeightProduct(width) {
        var height = (width * 1769) / 2745;
        return height;
    };

    calHeightDoulbure(width) {
        //var height = (width * 1254) / 741;
        var height = (width * 1306) / 686;
        return height;
    };

    in_object(value, obj) {
        if (Object.values(obj).indexOf(value) > -1) {
            return true;
        }
        return false;
    };

    findKey(object, value) {
        for (let key in object) if (object[key] === value) return key;

        return "key is not found";
    };

    applyFilterAdmin(canvasName, index, filter) {
        let obj = getObject(canvasName, "fabricObj_fond", 'picture');
        obj.filters[index] = filter;
        obj.applyFilters();
        canvasName.renderAll();
    };

    applyFilterValueAdmin(canvasName, index, prop, value) {
        console.log(
            "applyFilterValue index : " + index + " prop :" + prop + " value:" + value
        );

        let obj = getObject(canvasName, "fabricObj_fond", 'picture');
        if (prop === "brightness" && !obj.filters[index]) {
            applyFilterAdmin(
                5,
                new f.Brightness({
                    brightness: value / 1000,
                })
            );
            console.log("new f.Brightness");
            console.log(obj.filters[index]);
        }
        if (obj.filters[index]) {
            console.log("filtre existant -> modification valeur");
            obj.filters[index][prop] = value / 100;
            obj.applyFilters();
            canvasName.renderAll();
        }
    };

    async promiseLoop(data) {
        console.log("[promiseLoop]", data);
        const dataParent = this.dataParent;
        dataParent.storage.data = data;
        // IMPORTANT FOR SYNC
        return new Promise(function (resolve, reject) {
            // CREATION ZONE CANVAS PRODUIT FACE AVANT
            var canvasProduit = false;

            canvasProduit = new fabric.StaticCanvas(
                "canvas_produit_html_" + data.iterationLoop,
                {
                    width: data.widthCanvasDBorigin,
                    height: data.heightCanvasDBorigin,
                    preserveObjectStacking: false,
                    stateful: true,
                    overlayVpt: false, //important
                    BackgroundVpt: true,
                    centeredScaling: true,
                    objectCaching: false,
                }
            );
            console.log("[beforecanvasProduit.loadFromJSON]", canvasProduit);
            const res = canvasProduit.loadFromJSON(dataParent.storage.stepJsonCanvas[dataParent.storage.id_product][data.iterationLoop], async function () {
                console.log("[aftercanvasProduit.loadFromJSON]", canvasProduit);
                let allPromises = new Array();
                canvasProduit.setZoom(data.multiplicateurCanvasWidth);

                canvasProduit.setWidth(
                    data.widthCanvasDBorigin * canvasProduit.getZoom()
                );
                canvasProduit.setHeight(
                    data.heightCanvasDBorigin * canvasProduit.getZoom()
                );

                canvasProduit.renderAll.bind(canvasProduit);
                canvasProduit.calcOffset();

                if (dataParent.storage.pyml.mask && dataParent.storage.pyml.mask.aditionalZoom) {
                    canvasProduit.zoomToPoint(
                        {
                            x: canvasProduit.width / 2,
                            y: canvasProduit.height / 2,
                        },
                        data.multiplicateurCanvasWidth +
                        dataParent.storage.pyml.mask.aditionalZoom
                    );
                }

                const promise_faceAV = await dataParent.class.Back.addfaceAVToPDF(canvasProduit, data);
                if (data.iterationLoop === 1 && typeof dataParent.storage.pyml.entrejambe != "undefined") {
                    // const promise_entrejambe = await dataParent.class.Back.entrejambe(canvasProduit, data);
                    const promise_entrejambe = await dataParent.class.Back.entrejambetest(canvasProduit, data);
                    console.log("!!!! TEST --- PUSH PROMISE ENTRE JAMBE IN ALLPROMISE");

                }

                if (data.iterationLoop === 1 && typeof dataParent.storage.pyml.ceinture != "undefined") {
                    console.log('dataParent.storage just before add belt', dataParent.storage);
                    const promise_Belt = dataParent.class.Back.addBeltToPDF(canvasProduit, dataParent.storage.pyml);
                }



                if (data.iterationLoop === data.jsonStepCanvas.nbstep && typeof dataParent.storage.pyml.doublure != "undefined") {
                    const promise_doublure = await dataParent.class.Back.doublure(canvasProduit, data);
                    console.log("PUSH PROMISE DOUBLE IN ALLPROMISE");
                }

                canvasProduit.renderAll.bind(canvasProduit);
                canvasProduit.calcOffset();

                // LAST ITERATION
                if (data.iterationLoop === data.jsonStepCanvas.nbstep) {
                    dataParent.class.Back.traceTexts(dataParent.storage.docPdf, data);
                    dataParent.class.Back.addDoublureToPDF(canvasProduit, dataParent.storage.pyml);
                    dataParent.class.Back.addEntrejambeToPDF(canvasProduit, dataParent.storage.pyml);
                    if (typeof dataParent.storage.pyml.bande != "undefined") {
                        console.log('dataParent.storage just before add bande', dataParent.storage);
                        const promise_Band = dataParent.class.Back.addBandToPDF(canvasProduit, dataParent.storage.pyml);
                    }
                }
                canvasProduit.renderAll.bind(canvasProduit);
                canvasProduit.calcOffset();
                console.log("[resolve promise]");
                resolve("promiseLoop " + data.iterationLoop + " resolved");
                reject('erreur promise loop')
                console.log("promiseLoop " + data.iterationLoop + " resolved");
            });
        });
    };

    generateProject(dataProject) {
        const dataParent = this.dataParent;

        var str = dataProject.taille;
        str = str.replace(" ans", "");
        dataProject.taille = str;
        dataParent.storage.back.project = {
            id_personnalisation: dataProject.id_personnalisation,
            id_order: dataProject.id_order,
            id_customization: dataProject.id_customization,
            taille: dataProject.taille,
        }


        fabric.Object.NUM_FRACTION_DIGITS = 17;
        fabric.Object.prototype.objectCaching = false;
        console.log('dataProject', dataProject);


        dataParent.class.Canvas.jsonLoadCanvasDB(dataParent.storage.back.project).done(async function (json) {
            console.log("jsonLoadCanvasDB FROM DB", json);
            if (json.success === true) {
                dataParent.storage.id_product = json.id_product;
                dataParent.storage.pyml = dataParent.class.Ajax.getPyml(json.id_product);
                dataParent.storage.stepJsonCanvas = json.stepJsonCanvas;

                console.log("dataParent.storage.pyml", dataParent.storage.pyml);
                console.log("dataParent.storage FROM DB", dataParent.storage);
                console.log('stepJsonCanvas from db', dataParent.storage.stepJsonCanvas[dataParent.storage.id_product][1]);
                var type_produit = json.type_produit;

                var qty = [];
                json.attributes.forEach(function (attribute) {
                    qty.push(attribute.quantity);
                });
                dataParent.storage.key_taille = dataParent.class.Back.findKey(dataParent.storage.pyml.taille, dataProject.taille);
                dataParent.storage.docPdf = dataParent.class.Back.createPDF(
                    parseFloat(dataParent.storage.pyml.pdf.width[dataParent.storage.key_taille]),
                    parseFloat(dataParent.storage.pyml.pdf.height[dataParent.storage.key_taille])
                );

                dataParent.storage.id_order = json.id_order;
                var id_personnalisation = json.id_personnalisation;
                var widthCanvasDBorigin = 2745 * dataParent.storage.stepJsonCanvas[dataParent.storage.id_product][1].overlayImage.scaleX;
                var heightCanvasDBorigin = 1769 * dataParent.storage.stepJsonCanvas[dataParent.storage.id_product][1].overlayImage.scaleY;
                var multiplicateurCanvasWidth = 2745 / widthCanvasDBorigin;


                //console.log("json.stepCanvas1", json.stepCanvas1);
                if (dataParent.storage.stepJsonCanvas[dataParent.storage.id_product][1].nbstep === undefined) {
                    dataParent.storage.stepJsonCanvas[dataParent.storage.id_product][1].nbstep = 1;
                }
                //console.log('json.stepCanvas1.nbstep', json.stepCanvas1.nbstep);
                for (var iterationLoop = 1; iterationLoop <= dataParent.storage.stepJsonCanvas[dataParent.storage.id_product][1].nbstep; iterationLoop++) {
                    var dataLoop = [];
                    dataLoop.docPdf = dataParent.storage.docPdf;
                    dataLoop.widthCanvasDBorigin = widthCanvasDBorigin;
                    dataLoop.heightCanvasDBorigin = heightCanvasDBorigin;
                    dataLoop.json = json;
                    dataLoop.taille = dataProject.taille;
                    dataLoop.iterationLoop = iterationLoop;
                    dataLoop.jsonStepCanvas = dataParent.storage.stepJsonCanvas[dataParent.storage.id_product][iterationLoop];
                    dataLoop.id_customization = json.id_customization;
                    dataLoop.multiplicateurCanvasWidth = multiplicateurCanvasWidth;
                    console.log("iteration " + iterationLoop + " go");

                    const res = await dataParent.class.Back.promiseLoop(dataLoop);
                }

                dataParent.class.Dom.updateLoading("- création du PDF en cours ...", "outPDF");
                dataParent.class.Back.outPDF(
                    dataParent.storage.docPdf,
                    id_personnalisation,
                    "ORDER_" + dataParent.storage.id_order + "_IDC_" + dataProject.id_customization + "_T" + dataProject.taille + "_" + type_produit.toUpperCase()
                );
            }
        });
    };

}